import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.25 13.3H0.299988V35.87H65.25V13.3Z" fill="white" />
    <path d="M65.65 34.485H0.699982V50.25H65.65V34.485Z" fill="#0052B4" />
    <path d="M65.25 0.300003H0.299988V15.87H65.25V0.300003Z" fill="#D80027" />
    <path d="M31 16.3H28V12.3L30.7 10.3L33.4 12.3V16.3H31Z" fill="#338AF3" />
    <path d="M19.2 16.3L22.6 16.4V12.4L19.9 10.4L17.2 12.4V16.4H19.2V16.3Z" fill="#338AF3" />
    <path d="M27.9 16.3L22.5 16.4V12.4L25.2 10.4L27.9 12.4V16.3Z" fill="#0052B4" />
    <path
      d="M26.9 35.3L28.8 33.6L30 33.9C31.0013 33.1393 31.8118 32.1559 32.3672 31.0277C32.9227 29.8995 33.2078 28.6575 33.2 27.4V16.3"
      fill="white"
    />
    <path
      d="M17.2 16.3V27.4C17.214 28.6537 17.5087 29.8883 18.0625 31.0131C18.6163 32.1379 19.415 33.1244 20.4 33.9L21.8 33.5L23.6 35.3"
      fill="white"
    />
    <path d="M20.4 16.3V19.5H17.2V16.3" fill="#D80027" />
    <path d="M26.9 16.3V19.5H23.7V16.3" fill="#D80027" />
    <path d="M33.3 16.3V19.5H30.1V16.3" fill="#D80027" />
    <path d="M20.4 19.5H23.6V22.7H20.4V19.5Z" fill="#D80027" />
    <path d="M26.9 19.5H30.1V22.7H26.9V19.5Z" fill="#D80027" />
    <path d="M17.2 22.8H20.4V26H17.2V22.8Z" fill="#D80027" />
    <path d="M20.4 26H23.6V29.2H20.4V26Z" fill="#D80027" />
    <path d="M23.7 22.8H26.9V26H23.7V22.8Z" fill="#D80027" />
    <path d="M30.1 22.8H33.3V26H30.1V22.8Z" fill="#D80027" />
    <path d="M26.9 26H30.1V29.2H26.9V26Z" fill="#D80027" />
    <path d="M23.7 29.2H26.9V32.5H23.7V29.2Z" fill="#D80027" />
    <path d="M20.4 29.2H17.3C17.5654 30.3808 18.1145 31.4792 18.9 32.4H20.4V29.2Z" fill="#D80027" />
    <path d="M30.1 32.5H31.6C32.3666 31.5669 32.9134 30.4732 33.2 29.3H30.1V32.5Z" fill="#D80027" />
    <path d="M23.7 35.3V32.5H20.5V33.9C21.4796 34.5447 22.5617 35.0181 23.7 35.3" fill="#D80027" />
    <path d="M26.9 35.4C28.0736 35.1702 29.1726 34.6551 30.1 33.9V32.5H26.9V35.4Z" fill="#D80027" />
    <path d="M23.7 16.3V19.5H20.5V16.3" fill="white" />
    <path d="M30.2 16.3V19.5H27V16.3" fill="white" />
    <path d="M23.7 29.2V32.5H20.5V29.3" fill="white" />
    <path d="M30.2 29.2V32.5H27V29.3" fill="white" />
    <path
      d="M26.9 35.3C26.3897 35.4912 25.8416 35.5597 25.3 35.5C24.4 35.5 23.7 35.5 23.7 35.3C24.1933 35.0482 24.7489 34.944 25.3 35C25.8511 34.944 26.4066 35.0482 26.9 35.3V35.3Z"
      fill="white"
    />
    <path d="M26.9 32.5V35.4H23.7V32.5" fill="white" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
